export default __webpack_public_path__ + "static/media/BloodCell - Texture2.471eced6.jpg";